/**
 * サブヘッダー
 */
import { Component } from '@angular/core';
import { CommonLibService } from '@lib/services';
import { SupportComponent } from '@lib/components/support-class';
import { Router } from '@angular/router';
import { BookingSearchService } from '@common/services/booking-search/booking-search.service';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { MyBookingService } from '@common/services/my-booking/my-booking.service';

/**
 * サブヘッダー
 */
@Component({
  selector: 'asw-booking-list-sub-header',
  templateUrl: './booking-list-sub-header.component.html',
  providers: [],
})
export class BookingListSubHeaderComponent extends SupportComponent {
  public displayTitle: string = 'label.reservationList';

  constructor(private _common: CommonLibService, private _router: Router, private _myBookingService: MyBookingService) {
    super(_common);
  }

  // 3. 戻るボタン押下処理
  eventBack() {
    // 予約検索画面(S01-P010)へ遷移する。
    this._router.navigate([SERVICING_ROUTES.bookingSearch]);
  }

  reload(): void {}
  init(): void {}
  destroy(): void {}
}
